export default __webpack_public_path__ + "static/phone-picture-c6ad79359c0d06f72a2bf2d227e5ab7b.png";